'use client';
import { SearchMode, SearchModel } from '#pplx/frontend/ask-models/types/search-modes.js';
import React, { createContext, useContext } from 'react';
export function limitInfoFromNumber(count) {
    return {
        available: count > 0,
        exactCount: count,
    };
}
export function limitInfoFromRateLimit(limit) {
    return {
        available: limit.available,
        exactCount: limit.remaining_detail.kind === 'exact' ? limit.remaining_detail.remaining : undefined,
    };
}
export const state = {
    sources: ['web'],
    gpt4Limit: { available: false, exactCount: 0 },
    pplxAlphaLimit: { available: false, exactCount: 0 },
    pplxBetaLimit: { available: false, exactCount: 0 },
    agenticResearchLimit: { available: false, exactCount: 0 },
    modelSpecificLimits: {},
    uploadRateLimit: undefined,
    createLimit: 0,
    setConfiguredModel() { },
    askDeepResearchModel: null,
    showAskDeepResearchEducation: false,
    setAskDeepResearchModel() { },
    resetThreadConfig: () => { },
    setSources: () => { },
    decrementCreateLimit: () => { },
    setModelSpecificLimits: () => { },
    setUploadRateLimit: () => { },
    configuredModel: SearchModel.DEFAULT,
    hideSearchModeToggle: false,
    initialConfiguredModelIsLoading: false,
    compareModels: [],
    setCompareModels() { },
    exhaustedSearchMode: undefined,
    setExhaustedSearchMode() { },
};
export const ThreadConfigContext = createContext(state);
ThreadConfigContext.displayName = 'ThreadConfigContext';
export const useThreadConfig = () => {
    const ctx = useContext(ThreadConfigContext);
    if (!ctx)
        throw new Error('useThreadConfig must be used within ThreadSettingsContext');
    return ctx;
};
//# sourceMappingURL=ThreadSettingsProviderShared.js.map